import { Report } from '@philips-emr/hpms-provider-accreditation-commons';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

class HpmsReportListApi extends ComponentAPI<any> {
  @AwesomeEvent
  onClick = new ClickEventListener();

  setData(data: Report[]): void {
    this.setState({ data });
  }

  setLoading(value: boolean): void {
    this.setState({ loading: value });
  }
}

export default HpmsReportListApi;
